import script from "./NavMain.vue?vue&type=script&setup=true&lang=js"
export * from "./NavMain.vue?vue&type=script&setup=true&lang=js"

import "./NavMain.vue?vue&type=style&index=0&id=65ef5a06&lang=scss"

const __exports__ = script;

export default __exports__